
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundles/[bundleId]",
      function () {
        return require("private-next-pages/bundles/[bundleId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundles/[bundleId]"])
      });
    }
  